import React from 'react';
import { useSelector } from 'react-redux';

import { signedInSelector } from 'shared/app/bundles/user';
import './shared/styles/color-palette.css';
import RewardsSubnav from './subnav';

import SR6RewardsPageHero from './hero';
import SR6RewardsPageHowItWorks from './how-it-works';
import GetStarted from './get-started';
import Partnerships from './partnerships';
import FAQs from './sr6-faq';
import MembershipTiers from './membership-tiers';

const UnauthRewardsPage = () => {
  const signedIn = useSelector(signedInSelector);
  return (
    <div className="bg-whiteSurfacePrimary1">
      {signedIn && <RewardsSubnav />}
      <SR6RewardsPageHero />
      <SR6RewardsPageHowItWorks />
      <MembershipTiers />
      <Partnerships />
      <GetStarted />
      <FAQs />
    </div>
  );
};

export default UnauthRewardsPage;
